import axios from "@/plugins/axios";
// import * as example from "./example";

let url = "/api/v1/shop/orders";

export const orders = {
    // ...example,
    get(data){
        return axios.get(`${url}/${data._id}`).then(result => result.data);
    },
    post(data){
        return axios.post(url, data).then(result => result.data);
    },
    pay(data){
        return axios.post(`${url}/${data._id}/pay`).then(result => result.data);
    }
}
